/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
// utils
// material
import { Button, displayModal } from '@insticator/insticator-ui';
import Space from 'material/space/space'
// content
// styles
import injectSheet from "react-jss";
import styles from './deleteproductgroupmodal_styles';
import Status from 'material/status/status';

/* ========== ~~~~~~~~~~ MODERATION CONFIG PAGE ~~~~~~~~~~ ========== */
const DeleteProductGroupModal  = injectSheet(styles)((props) => {
  const dispatch = useDispatch();


  const { groupLabel, status, onConfirm, onCancel } = props

  const [isProcessing, setIsProcessing] = useState(false)


  const handleCancel = () => {
    dispatch(displayModal(false))
    onCancel?.()
  }



  const handleDelete = () => {
    setIsProcessing(true)
    onConfirm?.()
    dispatch(displayModal(false))
  }


  return (
    <div className={'deleteproductgroupmodal'}>
      <h4>Are you sure?</h4>
        <p>
          This action will remove this product group from the list: 
        </p>
        <Space justifyContent={'center'} alignItems={'center'}>
          <strong>{groupLabel}</strong> <Status status={status} />
        </Space>
        <br />
        <Space style={{marginTop: '32px'}} alignItems={'center'} justifyContent={'center'}>
          <Button text='Cancel' variant='none' color='light' handleClick={handleCancel} />
          <Button 
            text='Confirm' 
            variant='primary' 
            processing={isProcessing} 
            handleClick={handleDelete} 
          />
        </Space>
    </div>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default DeleteProductGroupModal